import { configureStore } from '@reduxjs/toolkit';
import userSlice from './slices/userSlice';
import breadcumbSlice from './slices/breadcumbSlice';

export const store = configureStore({
  reducer: {
    userSlice,
    breadcumbSlice,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
